import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { headerSignInStyles } from "@insite/content-library/Widgets/Common/HeaderSignIn";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    canAddToCart: state.context?.settings?.settingsCollection?.productSettings?.canAddToCart,
});

interface OwnProps extends PageProps {}
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchWrapper: InjectableCss;
    headInfoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    rightLinks: InjectableCss;
    menuLinks: InjectableCss;
    stickProductsWrapper?: InjectableCss;
    stickProductsWrapperVisible?: InjectableCss;
    stickheadInfoWrapper?: InjectableCss;
    scrollFixed?: InjectableCss;
    scrollRightLinks?: InjectableCss;
    stickPhonenumber?: InjectableCss;
    stickLogo?: InjectableCss;
    stickHeaderStripe?: InjectableCss;
    headerStripe?: InjectableCss;

    shopNow?: InjectableCss;
    stickWrap?: InjectableCss;
    scrollmenuLinks?: InjectableCss;
    orderRestrictions?: InjectableCss;
    stickOrderRestrictions?: InjectableCss;
    stickyOrder?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            .wrapBlock {
                max-width: 1440px;
                width: 100%;
                margin: auto;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            position: static !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    orderRestrictions: {
        css: css`
            color: white;
            text-align: center;
            padding: 5px;
            background: #e64e25;
            width: 100%;
            span {
                font-weight: bold;
            }
        `,
    },
    stickOrderRestrictions: {
        css: css`
            position: fixed;
            top: 0;
            left: 0;
            color: white;
            text-align: center;
            padding: 5px;
            background: #e64e25;
            width: 100%;
            z-index: 3;
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            padding: 10px 15px;
            @media (max-width: 767px) {
                padding: 10px 15px;
            }
            [class^="Wrapper"] {
                // div {
                //     display: flex;
                // }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    stickLogo: {
        css: css`
            padding: 5px 15px;
            margin: auto 0;
            width: 11%;
            @media (max-width: 767px) {
                display: none;
            }
            [class^="Wrapper"] {
                // div {
                //     display: flex;
                // }
            }
            img {
                height: 40px;
                width: 100px;
                @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
                    width: 90px;
                }
            }
        `,
    },
    stickyOrder: {
        css: css`
            display: flex;
            justify-content: space-between;
            z-index: 100;
            position: fixed;
            top: 32px;
            left: 0;
            background: #333;
            width: 100%;
            height: 50px;
            * {
                transition: all 0.4s ease;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            transition: none !important;
                        `,
                    ],
                    "max",
                )}

            .logo {
                display: none;
            }
            .wrapBlock {
                max-width: 1440px;
                width: 100%;
                margin: auto;
            }
            [data-test-selector^="header_signIn"] {
                display: contents;
                span {
                    height: 50px;
                }
                p {
                    line-height: 50px;
                    margin-left: 5px;
                    font-weight: normal;
                }
            }
            .myAccount {
                [class^="TypographyStyle"] {
                    display: contents;
                    p {
                        [class^="IconWrapper"] {
                            margin-left: 5px;
                            svg {
                                color: #fff !important;
                            }
                        }
                    }
                }
            }
            .myAccountMenu {
                ul {
                    li {
                        a {
                            height: auto;
                            span {
                                color: #3666b1;
                            }
                        }
                        [class^="StyledButton"] {
                            color: #3666b1;
                            height: auto;
                        }
                    }
                }
            }
        `,
    },
    scrollFixed: {
        css: css`
            display: flex;
            justify-content: space-between;
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            background: #333;
            width: 100%;
            height: 50px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            position: static !important;
                        `,
                    ],
                    "max",
                )}
            * {
                transition: all 0.4s ease;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            transition: none !important;
                        `,
                    ],
                    "max",
                )}

            .logo {
                display: none;
            }
            .wrapBlock {
                max-width: 1440px;
                width: 100%;
                margin: auto;
            }
            [data-test-selector^="header_signIn"] {
                display: contents;
                span {
                    height: 50px;
                }
                p {
                    line-height: 50px;
                    margin-left: 5px;
                    font-weight: normal;
                }
            }
            [data-test-selector^="header_signIn1"] {
                display: none;
            }
            .myAccount {
                [class^="TypographyStyle"] {
                    display: contents;
                    p {
                        [class^="IconWrapper"] {
                            margin-left: 5px;
                            svg {
                                color: #fff !important;
                            }
                        }
                    }
                }
            }
            .myAccountMenu {
                ul {
                    li {
                        a {
                            height: auto;
                            span {
                                color: #3666b1;
                            }
                        }
                        [class^="StyledButton"] {
                            color: #3666b1;
                            height: auto;
                        }
                    }
                }
            }
        `,
    },
    searchWrapper: {
        css: css`
            @media (max-width: 767px) {
                width: 100%;
            }
            div[class^="Wrapper"] {
                border: 1px solid #3666b1;
                height: 40px;
                > div[class^="OverflowWrapper"] {
                    > div[id^="headerSearch"] {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        right: 0 !important;
                                    `,
                                    css`
                                        right: 0 !important;
                                    `,
                                    null,
                                    null,
                                ],
                                "minMax",
                            );
                        }}
                    }
                }

                [class^="FormFieldStyle"] {
                    width: 100%;
                }

                input[type="text"] {
                    border: none;
                    height: 38px;
                    background-color: transparent;
                }
                [class^="StyledButton"] {
                    [class^="IconWrapper"] {
                        background-color: rgb(54, 102, 177);
                        top: 1.6px;
                        right: 1.5px;
                        width: 35px;
                        height: 35px;
                        border-radius: inherit;
                        svg {
                            color: rgb(255, 255, 255);
                        }
                    }
                }
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            padding-right: 30px;
            margin: auto 0 auto 30px;
            div[class^="Wrapper"] {
                div {
                    padding: 0;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },

    headInfoWrapper: {
        css: css`
            margin: auto 0;
            width: 20%;
            padding: 8px 0px;
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                width: 30%;
            }
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                display: none;
            }
            div[class^="GridWrapper"] {
                div[class^="GridItemStyle"] {
                    &:first-child {
                        margin: auto;
                        padding-right: 10px;
                        div[class^="Wrapper"] {
                            display: flex;
                            flex-direction: row-reverse;
                            img {
                                height: 30px;
                                width: 80px;
                                margin-right: 8px;
                                margin-top: 2px;
                            }
                        }
                    }
                }
            }
            div[class^="ContentWrapper"] {
                padding-left: 10px;
                border-left: 1px solid #666;
                p {
                    font-size: 12px;
                    color: #666;
                    font-weight: bold;
                    margin: auto;
                }
            }
            @media (max-width: 767px) {
                display: none;
            }
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    rightLinks: {
        css: css`
            width: 30%;
            margin: auto 30px;
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                margin-left: 15px;
            }
            @media (max-width: 767px) {
                width: 100%;
                margin: auto 0;
            }
        `,
    },
    scrollRightLinks: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 30%;
            @media (max-width: 767px) {
                width: 50%;
                margin-right: 15px;
            }
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                width: 40%;
            }
            .search {
                width: 100%;
                height: 35px;
                margin: auto;
                div[class^="Wrapper"] {
                    border: none;
                    [class^="StyledButton"] {
                        height: 40px;
                        [class^="IconWrapper"] {
                            top: 1.5px;
                            width: 32px;
                            height: 32px;
                        }
                    }
                    input[type="text"] {
                        height: 35px;
                        background-color: #fff;
                    }
                }
            }
        `,
    },
    menuLinks: {
        css: css`
            display: flex;
            margin: auto 0;

            [class^="Wrapper"] {
                margin: auto;
                padding: 0 5px;
                > div {
                    display: block;
                    nav {
                        width: 100px;
                        [data-test-selector^="header_userName"] {
                            width: 100px;
                            display: block;
                        }
                    }
                }
                &:last-child {
                    margin-top: 8px;
                    position: relative;
                    @media (max-width: 991px) {
                        a {
                            p {
                                span {
                                    display: block;
                                    top: 0px;
                                    right: 8%;
                                }
                            }
                        }
                    }
                }
            }
            @media (max-width: 767px) {
                margin: auto 15px;
                [class^="Wrapper"]:not(:last-child) {
                    display: none;
                }
            }
            button[data-test-selector^="header_signIn"] {
                > span[class^="IconWrapper"] {
                    > svg {
                        height: 28px;
                    }
                }
                > p[class^="TypographyStyle"] {
                    margin-top: 2px;
                }
            }
            [class^="StyledButton"] {
                display: block;
                text-align: center;
                line-height: 10px;
                padding-left: 0;

                @media (max-width: 767px) {
                    padding: 0;
                }

                [class^="IconWrapper"] {
                    color: rgb(54, 102, 177);
                    width: 40px;
                    margin-right: 0;
                    @media (max-width: 767px) {
                        margin-right: 0;
                        margin-top: 5px;
                    }
                    svg {
                        height: 25px;
                        width: 50px;
                    }
                }
                p,
                span {
                    color: rgb(54, 102, 177);
                    font-size: 14px;
                    text-transform: inherit;
                    font-weight: normal;
                    margin-left: 0;
                    line-height: 20px;
                }
                [data-test-selector^="cartLinkQuantity"] {
                    background: #3666b1;
                    top: -5px;
                    right: 23%;
                    position: absolute;
                    color: white;
                    line-height: 10px;
                    border-radius: 50%;
                    padding: 3px;
                    font-size: 10px;
                    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                        right: 20%;
                    }
                }
            }
            button[data-test-selector="header_signIn"] {
                span[class^="TypographyStyle"] {
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    display: flex;
                    -webkit-box-align: center;
                    align-items: center;
                    text-decoration: none;
                    height: 22px;
                    vertical-align: middle;
                    text-align: center;
                }
            }
            [class^="ContentWrapper"] {
                height: 57px;
                padding-right: 5px;
                .location-block {
                    color: rgb(54, 102, 177);
                    height: 32px;
                    width: 40px;
                    margin: auto;

                    //img {
                    //height: 25px;
                    //width: 25px;
                    //}
                }
                .location-icon {
                    margin-bottom: 0px;
                }
            }
        `,
    },
    stickProductsWrapper: {
        css: css`
            display: none;
        `,
    },
    stickheadInfoWrapper: {
        css: css`
            display: none;
        `,
    },
    stickProductsWrapperVisible: {
        css: css`
            width: auto;
            margin: auto 0;
            padding-right: 15px;
       
            > div[class^="HiddenStyle"] {
                > div[class^="Wrapper"] {
                    > div[class^="sc"] {
                        > div[class^="HiddenStyle"]:last-child {
                            > div[class^="sc"] {
                                > div[class^="sc"]:last-child {
                                    position: unset;
                                }
                            }
                        }
                    }
                    > div:last-child[class^="HiddenStyle"] {
                        > div {
                            > div:last-child {
                                position: relative;
                            }
                        }
                    }
                }
            }
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                width: 42%;
                padding-right: 0;
                margin-right: -15px;
            }
            [data-test-selector^="expandMobileMenu"]{
                height: 40px;
                margin-left: 30px;
                @media (max-width: 767px) {
                    margin-left: 15px;
                }
            }
            nav{
                [aria-controls^="0_Solutions"]{
                    border-right: 2px solid #666;
                    padding: 0 15px;
                    margin-right: 15px;
                    margin-top: 2px;
                }
                button{
                    height: 35px;
                    padding: 0;
                    p, span{
                        width:  auto;
                        font-size: 16px;
                        font-weight: bold;
                        width: max-content;
                    }
                }
                [id^="0_Solutions"]{
                    .staticMenuPopover{
                        display: block !important;
                    }
                }
                [class^="PopoverStyle"]{
                    width: 85% !important;       
                    .staticMenuPopover{
                        display: none;
                        padding-bottom: 15px;
                        margin-bottom: 15px;
                        ul{
                            li{
                                width: 25%;
                                display: inline-block;
                                a{
                                    color: #3666B1;
                                    font-weight: bold;
                                    display: block;
                                    img{
                                        vertical-align: middle;
                                        margin-left: -15px;
                                    }
                                    span{
                                        font-size:12px;
                                    }
                                }
                            }
                        }
                }
            }
    }
        `,
    },
    stickPhonenumber: {
        css: css`
            width: 20%;
            margin: auto 0;
            padding: 0 30px;
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                width: 25%;
            }
            @media only screen and (max-width: 767px),
                only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                display: none;
            }
            .phone-block {
                text-align: center;
                border: 1px solid #000;
                padding: 3px 10px;
                background: #000;
                cursor: pointer;
                a {
                    height: 24px;
                    display: inline-block;
                    vertical-align: middle;
                    span {
                        color: #fff;
                        font-weight: 600;
                        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                            font-size: 12px;
                        }
                        &:hover {
                            color: #fff;
                        }
                    }
                }
                > a:last-child[class^="StyledButton"] {
                    margin-top: -13px;
                }
            }
        `,
    },
    headerStripe: {
        css: css`
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            position: static !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    stickHeaderStripe: {
        css: css`
            position: fixed;
            top: 50px;
            width: 100%;
            z-index: 3;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            position: static !important;
                        `,
                    ],
                    "max",
                )}
            * {
                transition: all 0.4s ease;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            transition: none !important;
                        `,
                    ],
                    "max",
                )}
            > div {
                width: 100%;
                line-height: 0;
                [class^="LazyImageStyle"] {
                    width: 100%;
                }
            }
        `,
    },
    shopNow: {
        css: css`
            margin: auto 0;
            background: #3666b1;
            margin-right: 15px;
            text-align: center;
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                width: 20%;
                margin-left: 15px;
            }
            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                width: 25%;
                margin-left: 15px;
            }
            @media (max-width: 767px) {
                display: none;
            }

            [class^="ContentWrapper"] {
                border: 1px solid #3666b1;
                padding: 1px;
                .shopNow {
                    padding: 10px 15px;
                    background: #3666b1;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding: 10px 10px;
                                `,
                                css`
                                    padding: 10px 10px;
                                `,
                            ],
                            "minMax",
                        )}
                    span {
                        color: #fff;
                        font-weight: bold;
                        vertical-align: middle;
                    }
                    img {
                        padding-right: 10px;
                    }
                }
            }
        `,
    },
    stickWrap: {
        css: css`
            display: none;
        `,
    },
    scrollmenuLinks: {
        css: css`
            width: auto;
            display: flex;
            justify-content: flex-end;
            [class^="Wrapper"] {
                &:first-child {
                    display: none;
                }
                width: auto;
                padding-right: 15px;
                position: relative;
                @media (max-width: 767px) {
                    &:nth-child(2) {
                        display: none;
                    }
                }
                [class^="StyledButton"] {
                    [data-test-selector^="cartLinkQuantity"] {
                        background: #3666b1;
                        top: 8px;
                        left: 20%;
                        position: absolute;
                        color: white;
                        line-height: 10px;
                        border-radius: 50%;
                        padding: 3px;
                        font-size: 10px;
                    }
                }
            }
            [class^="StyledButton"] {
                margin-left: 0;
                padding-left: 0;
                color: #fff;
                height: 50px;
                span {
                    vertical-align: middle;
                    font-weight: normal;
                }
                [class^="TypographyStyle"] {
                    color: #fff;
                    font-size: 14px;
                    text-transform: capitalize;
                    line-height: 20px;
                    margin-left: 0;
                    font-weight: normal;
                }
            }
            a[data-test-selector="header_signIn"] {
                > span[class^="TypographyStyle"] {
                    padding-top: 14px;
                }
            }
            button[data-test-selector^="header_signIn"] {
                [class^="TypographyStyle"] {
                    line-height: 50px;
                }
            }
        `,
    },
};
headerSignInStyles.signOutClickable = {
    css: css`
        text-transform: inherit;
        font-size: 14px;
        color: rgb(54, 102, 177);
        width: 100%;
        padding-left: 15px;
        &:hover {
            color: rgb(32, 70, 123);
        }
    `,
};

const LogoLinksSearch: React.FC<Props> = ({ id, canAddToCart }) => {
    const [offset, setOffset] = useState(0);
    const [currentDeviceWidth, setCurrentDeviceWidth] = React.useState(1366);
    useEffect(() => {
        window.onscroll = () => {
            const check = window.parent.document.getElementById("siteIFrame");
            if (!check) {
                setOffset(window.pageYOffset);
            } else {
                setOffset(2000);
            }
        };
    }, []);

    useEffect(() => {
        setCurrentDeviceWidth(window.screen.width);
        const handleResize = () => {
            setCurrentDeviceWidth(window.screen.width);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });

    // console.log("currentDeviceWidth", currentDeviceWidth);
    return (
        <>
            <StyledWrapper
                hidden={canAddToCart}
                {...logoLinksSearchStyles.orderRestrictions}
                {...(offset > 136 ? { ...logoLinksSearchStyles.stickOrderRestrictions } : "")}
            >
                <Typography>{siteMessage("Order_Restriction")}</Typography>
            </StyledWrapper>

            <StyledWrapper
                {...(offset > 136 ? { ...logoLinksSearchStyles.scrollFixed } : { ...logoLinksSearchStyles.container })}
                {...(offset > 136 && !canAddToCart ? { ...logoLinksSearchStyles.stickyOrder } : "")}
            >
                <StyledWrapper {...logoLinksSearchStyles.container} className="wrapBlock">
                    <StyledWrapper className="logo" {...logoLinksSearchStyles.logoWrapper}>
                        <Zone contentId={id} zoneName="Logo" />
                    </StyledWrapper>
                    <StyledWrapper
                        className="sticklogo"
                        {...logoLinksSearchStyles.stickheadInfoWrapper}
                        {...(offset > 136 ? { ...logoLinksSearchStyles.stickLogo } : "")}
                    >
                        <Hidden>
                            <Zone contentId={id} zoneName="StickLogo" />
                        </Hidden>
                    </StyledWrapper>
                    {offset > 136 && currentDeviceWidth >= 768 ? (
                        <StyledWrapper
                            {...logoLinksSearchStyles.stickheadInfoWrapper}
                            {...(offset > 136 ? { ...logoLinksSearchStyles.stickProductsWrapperVisible } : "")}
                        >
                            <Hidden>
                                <Zone contentId={id} zoneName="productMenuSticky" />
                            </Hidden>
                        </StyledWrapper>
                    ) : (
                        ""
                    )}
                    <StyledWrapper
                        {...logoLinksSearchStyles.headInfoWrapper}
                        {...(offset > 136 ? { ...logoLinksSearchStyles.stickheadInfoWrapper } : "")}
                    >
                        <Zone contentId={id} zoneName="headInfoWrapper" />
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.rightLinks}
                        {...(offset > 136 ? { ...logoLinksSearchStyles.scrollRightLinks } : "")}
                    >
                        <StyledWrapper {...logoLinksSearchStyles.searchWrapper} className="search">
                            <Hidden>
                                <Zone contentId={id} zoneName="Search" fixed />
                            </Hidden>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.stickheadInfoWrapper}
                        {...(offset > 136 ? { ...logoLinksSearchStyles.stickPhonenumber } : "")}
                    >
                        <Zone contentId={id} zoneName="stickyPhoneNumber" />
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.menuLinks}
                        {...(offset > 136 ? { ...logoLinksSearchStyles.scrollmenuLinks } : "")}
                        className="rightLinks"
                    >
                        <Zone contentId={id} zoneName="locations" />
                        <Zone contentId={id} zoneName="sign-in" />
                        <Zone contentId={id} zoneName="cart" />
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.shopNow}
                        {...(offset > 136 ? { ...logoLinksSearchStyles.stickWrap } : "")}
                    >
                        <Zone contentId={id} zoneName="shopNow" />
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper
                {...logoLinksSearchStyles.headerStripe}
                {...(offset > 136 ? { ...logoLinksSearchStyles.stickHeaderStripe } : "")}
            >
                <Hidden>
                    <Zone contentId={id} zoneName="stickHeaderStripe" />
                </Hidden>
            </StyledWrapper>
        </>
    );
};

const logoLinksSearch: WidgetModule = {
    component: connect(mapStateToProps)(LogoLinksSearch),
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
